/**
 * Blog Data Configuration
 * This file contains blog posts and blog-related data
 * Can be easily replaced with API calls in the future
 */

export const blogPosts = [
  {
    id: 1,
    title: 'QUICK CRAVINGS: UNRAVELING FAST FOOD DELIGHTS',
    slug: 'quick-cravings-fast-food-delights',
    excerpt: 'Discover the most satisfying fast food options that will curb your hunger instantly. From juicy burgers to crispy fries, explore our top picks for quick meals.',
    content: 'Full blog content about fast food delights...',
    author: 'Gudiya Cooking Team',
    authorAvatar: 'author1',
    date: '2024-01-15',
    readTime: '5 min read',
    category: 'Fast Food',
    categorySlug: 'fast-food',
    image: 'delicious-burger.png',
    tags: ['fast-food', 'burgers', 'quick-meals'],
    featured: true,
    comments: 24,
    likes: 156,
    views: 892,
  },
  {
    id: 2,
    title: 'THE ART OF PERFECT PIZZA MAKING',
    slug: 'art-perfect-pizza-making',
    excerpt: 'Learn the secrets behind creating the perfect pizza with authentic Italian techniques and premium ingredients that elevate your homemade pies.',
    content: 'Full blog content about pizza making...',
    author: 'Chef Kumar',
    authorAvatar: 'author2',
    date: '2024-01-12',
    readTime: '8 min read',
    category: 'Pizza',
    categorySlug: 'pizza',
    image: 'big-pizza.png',
    tags: ['pizza', 'italian', 'cooking-tips'],
    featured: true,
    comments: 18,
    likes: 203,
    views: 1245,
  },
  {
    id: 3,
    title: 'CRISPY CHICKEN: THE ULTIMATE GUIDE',
    slug: 'crispy-chicken-ultimate-guide',
    excerpt: 'Master the technique of achieving perfectly crispy chicken every time with our comprehensive guide covering marinades, cooking methods, and seasoning secrets.',
    content: 'Full blog content about crispy chicken...',
    author: 'Gudiya Cooking Team',
    authorAvatar: 'author3',
    date: '2024-01-10',
    readTime: '6 min read',
    category: 'Fried Chicken',
    categorySlug: 'fried-chicken',
    image: 'fried-chicken-2.png',
    tags: ['chicken', 'fried-food', 'cooking-tips'],
    featured: true,
    comments: 32,
    likes: 189,
    views: 756,
  },
  {
    id: 4,
    title: 'FRENCH FRIES PERFECTION: TIPS & TRICKS',
    slug: 'french-fries-perfection-tips-tricks',
    excerpt: 'Transform your potato game with these professional tips for creating restaurant-quality French fries that are crispy on the outside and fluffy on the inside.',
    content: 'Full blog content about French fries...',
    author: 'Chef Patel',
    authorAvatar: 'author3',
    date: '2024-01-08',
    readTime: '4 min read',
    category: 'French Fries',
    categorySlug: 'french-fries',
    image: 'french-fry.png',
    tags: ['fries', 'potatoes', 'cooking-tips'],
    featured: false,
    comments: 15,
    likes: 98,
    views: 543,
  },
  {
    id: 5,
    title: 'SANDWICH MASTERY: BEYOND THE BASICS',
    slug: 'sandwich-mastery-beyond-basics',
    excerpt: 'Elevate your sandwich game with creative combinations, premium ingredients, and professional assembly techniques that will transform your lunch experience.',
    content: 'Full blog content about sandwiches...',
    author: 'Gudiya Cooking Team',
    authorAvatar: 'author1',
    date: '2024-01-05',
    readTime: '7 min read',
    category: 'Sandwich',
    categorySlug: 'sandwich',
    image: 'grilled.png',
    tags: ['sandwich', 'lunch', 'creative'],
    featured: true,
    comments: 22,
    likes: 167,
    views: 678,
  },
];

export const blogCategories = [
  {
    id: 'burger',
    name: 'Burger',
    slug: 'burger',
    count: 12,
    color: '#ff6b35',
  },
  {
    id: 'fried-chicken',
    name: 'Fried Chicken',
    slug: 'fried-chicken',
    count: 8,
    color: '#d32f2f',
  },
  {
    id: 'french-fries',
    name: 'French Fries',
    slug: 'french-fries',
    count: 6,
    color: '#ffc107',
  },
  {
    id: 'pizza',
    name: 'Pizza',
    slug: 'pizza',
    count: 15,
    color: '#2e7d32',
  },
  {
    id: 'sandwich',
    name: 'Sandwich',
    slug: 'sandwich',
    count: 9,
    color: '#1976d2',
  },
];

export const popularFeeds = [
  {
    id: 1,
    title: '10 Best Burger Recipes',
    thumbnail: 'burger.png',
    date: '2024-01-14',
    readTime: '3 min read',
  },
  {
    id: 2,
    title: 'Pizza Dough Secrets',
    thumbnail: 'pizza.png',
    date: '2024-01-13',
    readTime: '5 min read',
  },
  {
    id: 3,
    title: 'Perfect Fried Chicken',
    thumbnail: 'chiken.png',
    date: '2024-01-11',
    readTime: '4 min read',
  },
  {
    id: 4,
    title: 'Homemade Fries Guide',
    thumbnail: 'french-fry.png',
    date: '2024-01-09',
    readTime: '6 min read',
  },
  {
    id: 5,
    title: 'Gourmet Sandwich Ideas',
    thumbnail: 'grilled.png',
    date: '2024-01-07',
    readTime: '7 min read',
  },
];

/**
 * Get blog posts from API (placeholder for future implementation)
 * @returns {Promise<Array>} Array of blog posts
 */
export const getBlogPostsFromAPI = async () => {
  try {
    // Future API call: const response = await api.get('/blog-posts');
    // return response.data;
    
    // For now, return static data
    return new Promise((resolve) => {
      setTimeout(() => resolve(blogPosts), 100);
    });
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    return blogPosts;
  }
};

/**
 * Get featured blog posts only
 * @returns {Array} Array of featured blog posts
 */
export const getFeaturedBlogPosts = () => {
  return blogPosts.filter(post => post.featured);
};

/**
 * Get blog posts by category
 * @param {string} categorySlug - Category slug
 * @returns {Array} Array of blog posts in category
 */
export const getBlogPostsByCategory = (categorySlug) => {
  return blogPosts.filter(post => post.categorySlug === categorySlug);
};

/**
 * Get blog post by slug
 * @param {string} slug - Blog post slug
 * @returns {Object|null} Blog post object or null
 */
export const getBlogPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug) || null;
};

export default blogPosts;
